<div class="bg-background/60 backdrop-blur-[6px] flex items-center justify-center absolute inset-0 z-50 h-full w-full rounded-[inherit]">
  <hlm-spinner class="text-4xl text-primary" aria-label="Caricamento" />
</div>
